import { render, staticRenderFns } from "./dialog-form-title-buttons.vue?vue&type=template&id=febc0f80&"
import script from "./dialog-form-title-buttons.vue?vue&type=script&lang=ts&"
export * from "./dialog-form-title-buttons.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-form-title-buttons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports